<template>
  <div>
    <div v-if="disconnectSwitch">
      <h4>Details for {{disconnectSwitch.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{disconnectSwitch[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="disconnectSwitch.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "disconnectSwitch",
  components: {
    BFR
  },
  props: {
    disconnectSwitch: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["handleType", "Handle Type"],
      ["voltage", "Voltage"],
      ["currentRating", "Current Rating"],
      ["horsePowerRating", "Horse Power Rating"],
      ["enclosureType", "Enclosure Type"],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
